import TextSeparator from '@ifca-root/react-component/src/components/Typography/TextSeparator'
import { Chip, ListItemText } from '@material-ui/core'
import 'date-fns'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { toProperCase } from 'helpers/StringNumberFunction/StringConverter'
import React from 'react'

export const commonList = (el, module, status?) => {
  switch (module) {
    case 'Guarantee':
      return (
        <ListItemText
          primary={
            <>
              <span className="xsTitle flex-space">{el?.name}</span>
            </>
          }
          secondary={
            <span className="desc">
              <span className="text">Last updated on</span>
              <span className="color-blue"> {formatDate(el?.modTs)}</span>
            </span>
          }
        />
      )
    case 'Insurance':
      return (
        <ListItemText
          primary={
            <>
              <span className="xsTitle flex-space">{el?.name}</span>
            </>
          }
          secondary={
            <span className="desc">
              <span className="text">Last updated on</span>
              <span className="color-blue"> {formatDate(el?.modTs)}</span>
            </span>
          }
        />
      )
    case 'DocType':
      return (
        <ListItemText
          primary={
            <>
              <span className="xsTitle flex-space">{el?.docName}</span>
            </>
          }
          secondary={
            <span className="desc">
              <span className="">{el?.docCode} </span>
            </span>
          }
        />
      )

    case 'CostCenter':
      return (
        <ListItemText
          primary={
            <>
              <span className="xsTitle flex-space">{el?.code}</span>
            </>
          }
          secondary={
            <span className="desc">
              <span className="">{el?.description} </span>
            </span>
          }
        />
      )

    case 'Tax':
      return (
        <ListItemText
          primary={
            <>
              <span className="xsTitle flex-space">{el?.code ?? el?.Code}</span>
            </>
          }
          secondary={
            <span className="desc">
              <span className="text-noflow">
                {el?.name ?? el?.Description}{' '}
              </span>
            </span>
          }
        />
      )

    case 'Tax Effective Date':
      return (
        <ListItemText
          primary={
            <>
              <span className="xsTitle flex-space">
                {el?.date?.substr(0, 10)}
              </span>
            </>
          }
          secondary={
            <span className="desc">
              <span className="">{el?.taxRate}%</span>
            </span>
          }
        />
      )

    case 'Tax Scheme':
      return (
        <ListItemText
          primary={
            <>
              <span
                className="xsTitle flex-space"
                style={{
                  color: el?.RecordStatus === 'INACTIVE' ? '#BDBDBD' : null,
                }}
              >
                {el?.Description}
                {/* {`${el?.Description} (${el?.Code})`} */}
              </span>
              <span
                className="xxTitle"
                style={{
                  color: el?.RecordStatus === 'INACTIVE' ? '#BDBDBD' : null,
                }}
              >
                {el?.Code}
              </span>
            </>
          }
          secondary={
            <>
              <span
                className="desc flex-space"
                style={{
                  color: el?.RecordStatus === 'INACTIVE' ? '#BDBDBD' : null,
                }}
              >
                Effective Date:
                <span className="fw-medium p-l-3">
                  {el?.LatestTax === null
                    ? el?.TaxEffective?.length !== 0
                      ? formatDate(
                          el?.TaxEffective?.reduce((a, b) => {
                            return new Date(a?.Date) > new Date(b?.Date) ? a : b
                          })?.Date
                        )
                      : 'N/A'
                    : formatDate(el?.LatestTax?.Date)}
                  {/* {` ${formatDate(
                  // el?.LatestTax?.Date
                  el?.LatestTax === null
                    ? el?.TaxEffective?.reduce((a, b) => {
                        return new Date(a?.Date) > new Date(b?.Date) ? a : b
                      })?.Date
                    : el?.LatestTax?.Date
                )}`} */}
                </span>
                <TextSeparator></TextSeparator>
                <span className="fw-medium">
                  {el?.LatestTax === null
                    ? el?.TaxEffective?.length !== 0
                      ? el?.TaxEffective?.reduce((a, b) => {
                          return new Date(a?.Date) > new Date(b?.Date) ? a : b
                        })?.Rate
                      : 'N/A'
                    : el?.LatestTax?.Rate}
                  {/* {el?.LatestTax === null
                  ? el?.TaxEffective?.reduce((a, b) => {
                      return new Date(a?.Date) > new Date(b?.Date) ? a : b
                    })?.Rate
                  : el?.LatestTax?.Rate} */}
                  %
                </span>
              </span>
              <span
                className="xxTitle highlight-text"
                style={{
                  color: el?.RecordStatus === 'INACTIVE' ? '#BDBDBD' : null,
                }}
              >
                {toProperCase(el?.AccTaxClass)}
              </span>
            </>
          }
        />

        // <ListItemText
        //   primary={
        //     <>
        //       <span
        // style={{
        //   textDecoration:
        //     el?.RecordStatus === 'INACTIVE' ? 'line-through' : null,
        //         }}
        //         className="xsTitle flex-space"
        //       >
        //                    <span className="xsTitle flex-space">{el?.code}</span>
        //       <span className="xxTitle click-text highlight-text">
        //         {el?.RecordStatus}
        //       </span>
        //       </span>
        //     </>
        //   }
        //   secondary={
        //     <span
        //       style={{
        //         textDecoration:
        //           el?.RecordStatus === 'INACTIVE' ? 'line-through' : null,
        //       }}
        //       className="desc"
        //     >
        //       <span className="">{el?.description} </span>
        //     </span>
        //   }
        // />
      )

    // New Tax Setup
    case 'Common Tax Setup':
      return (
        <ListItemText
          primary={
            <>
              <span
                className="xsTitle flex-space"
                style={{
                  color: el?.tax_status === 'INACTIVE' ? '#BDBDBD' : null,
                }}
              >
                {el?.description}&nbsp;
                {el?.is_exempted === false ? null : (
                  <Chip
                    label={'Exempted Tax'}
                    variant="default"
                    className="c-orange desc"
                    style={{
                      height: '20px',
                      marginLeft: '5px',
                      backgroundColor: '#fff1de',
                    }}
                  />
                )}
              </span>
              <span
                className="xxTitle"
                style={{
                  color: el?.tax_status === 'INACTIVE' ? '#BDBDBD' : null,
                }}
              >
                {el?.code}
              </span>
            </>
          }
          secondary={
            <>
              <span
                className="desc flex-space"
                style={{
                  color: el?.tax_status === 'INACTIVE' ? '#BDBDBD' : null,
                }}
              >
                Effective Date:
                <span className="fw-medium p-l-3">
                  {el?.effective_date ? formatDate(el?.effective_date) : 'N/A'}
                </span>
                <TextSeparator></TextSeparator>
                <span className="fw-medium">
                  {el?.rate ? el?.rate : 'N/A'}%
                </span>
              </span>
              <span
                className="xxTitle highlight-text"
                style={{
                  color: el?.tax_status === 'INACTIVE' ? '#BDBDBD' : null,
                }}
              >
                {toProperCase(el?.class_type)}
              </span>
            </>
          }
        />
      )

    case 'Common Tax Scheme':
      return (
        <ListItemText
          primary={
            <>
              <span
                className="xsTitle flex-space"
                style={{
                  color: el?.commonStatus === 'INACTIVE' ? '#BDBDBD' : null,
                }}
              >
                {el?.name}&nbsp;
                {el?.isExclusive === true ? null : (
                  <Chip
                    label={'Inclusive Tax'}
                    variant="default"
                    className="c-orange desc"
                    style={{
                      height: '20px',
                      marginLeft: '5px',
                      backgroundColor: '#fff1de',
                    }}
                  />
                )}
              </span>
            </>
          }
          secondary={
            <span
              className="desc flex-space"
              style={{
                color: el?.commonStatus === 'INACTIVE' ? '#BDBDBD' : null,
              }}
            >
              {el?.description}
            </span>
          }
        />
      )

    default:
      return (
        <ListItemText
          primary={
            <>
              <span className="xsTitle flex-space">{el?.Code}</span>
              <span className="xxTitle click-text highlight-text">
                {/* {el?.RecordStatus} */}
              </span>
            </>
          }
          secondary={
            <span className="desc">
              <span className="">{el?.Name} </span>
            </span>
          }
        />
      )
  }
  // if (module == 'Guarantee') {
  //   return (
  //     <ListItemText
  //       primary={
  //         <>
  //           <span className="xsTitle flex-space">{el?.code}</span>
  //           <span className="xxTitle click-text highlight-text">
  //             {el?.RecordStatus}
  //           </span>
  //         </>
  //       }
  //       secondary={
  //         <span className="desc">
  //           <span className="fw-medium"> {el?.name}</span>
  //           {/* <TextSeparator></TextSeparator>
  //                       <span className="xxTitle click-text highlight-text">
  //                           {el?.RecordStatus}
  //                       </span> */}
  //           {/* <TextSeparator></TextSeparator>
  //                       <span className="xxTitle click-text highlight-text">
  //                           {el?.RecordStatus}
  //                       </span> */}
  //         </span>
  //       }
  //     />
  //   );
  // }
  // if (module == 'DocType') {
  //   return (
  //     <ListItemText
  //       primary={
  //         <>
  //           <span className="xsTitle flex-space">{el?.docName}</span>
  //           <span className="xxTitle click-text highlight-text">
  //             {el?.RecordStatus}
  //           </span>
  //         </>
  //       }
  //       secondary={
  //         <span className="desc">
  //           <span className="">{el?.docCode} </span>
  //           {/* <TextSeparator></TextSeparator>
  //                       <span className="xxTitle click-text highlight-text">
  //                           {el?.RecordStatus}
  //                       </span> */}
  //         </span>
  //       }
  //     />
  //   );
  // }
  // if (module == 'Tax') {
  //   return (
  //     <ListItemText
  //       primary={
  //         <>
  //           <span className="xsTitle flex-space">{el?.code}</span>
  //           <span className="xxTitle click-text highlight-text">
  //             {el?.RecordStatus}
  //           </span>
  //         </>
  //       }
  //       secondary={
  //         <span className="desc">
  //           <span className="">{el?.description} </span>
  //           {/* <TextSeparator></TextSeparator>
  //                       <span className="xxTitle click-text highlight-text">
  //                           {el?.RecordStatus}
  //                       </span> */}
  //         </span>
  //       }
  //     />
  //   );
  // } else {
  //   return (
  //     <ListItemText
  //       primary={
  //         <>
  //           <span className="xsTitle flex-space">{el?.code}</span>
  //           <span className="xxTitle click-text highlight-text">
  //             {el?.RecordStatus}
  //           </span>
  //         </>
  //       }
  //       secondary={
  //         <span className="desc">
  //           <span className="">{el?.name} </span>
  //           {/* <TextSeparator></TextSeparator> */}
  //           {/* <span className="xxTitle click-text highlight-text">
  //                           {el?.RecordStatus}
  //                       </span> */}
  //         </span>
  //       }
  //     />
  //   );
  // }
}

export const deleteForm = (name, code, module) => {
  switch (module) {
    case 'Guarantee':
      return (
        <>
          <div className="content-wrap full">
            <div className="desc">Name</div>
            <div className="xsTitle">{name}</div>
          </div>
        </>
      )
    case 'Insurance':
      return (
        <>
          <div className="content-wrap full">
            <div className="desc">Name</div>
            <div className="xsTitle">{name}</div>
          </div>
        </>
      )
    default:
      return (
        <>
          <div className="content-wrap full">
            <div className="desc">Code</div>
            <div className="xsTitle">{code}</div>
          </div>
          <div className="content-wrap full">
            <div className="desc">Tax Class</div>
            <div className="xsTitle">{name}</div>
          </div>
        </>
      )
  }
}

export const handleRecordStatus = status => {
  if (status == 'INACTIVE') {
    return true
  } else {
    return false
  }
}

export const TaxClassList = [
  {
    value: 'INPUT',
    label: 'INPUT',
  },
  {
    value: 'OUTPUT',
    label: 'OUTPUT',
  },
]
